export const TOKYO_STATION_POSITION: { lat: number; lng: number } = {
  lat: 35.681382,
  lng: 139.766084,
}
